import api from '@/api'

const state = {
  orderList: [],
  tempOrderList: [],
  orderDetail: {},
  tempOrderDetail: {},
  draftOrderDetail: {},
  draftOrderList: []
}
const actions = {
  getOrders({ commit }, { params }) {
    return new Promise((resolve, reject) => {
      api.order.orders(params).then(
        response => {
          commit('setOrders', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getTempOrders({ commit }, { params }) {
    return new Promise((resolve, reject) => {
      api.order.tempOrderList(params).then(
        response => {
          commit('setTempOrders', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  uploadOrder({ _ }, { payloads }) {
    return new Promise((resolve, reject) => {
      api.order.uploadOrder(payloads).then(
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  createMultipleOrder({ _ }, { payloads }) {
    return new Promise((resolve, reject) => {
      api.order.createMultipleOrder(payloads).then(
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  updateTempOrder({ _ }, { tempOrderId, payloads }) {
    return new Promise((resolve, reject) => {
      api.order.updateTempOrder(tempOrderId, payloads).then(
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getTempOrderDetail({ commit }, { tempOrderId }) {
    return new Promise((resolve, reject) => {
      api.order.tempOrderDetail(tempOrderId).then(
        response => {
          commit('setTempOrderDetail', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getOrderDetail({ commit }, { orderId }) {
    return new Promise((resolve, reject) => {
      api.order.orderDetail(orderId).then(
        response => {
          commit('setOrderDetail', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  deleteTempOrder({ _ }, { tempOrderId }) {
    return new Promise((resolve, reject) => {
      api.order.deleteTempOrder(tempOrderId).then(
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  processOrder({ _ }, { orderId }) {
    return new Promise((resolve, reject) => {
      api.order.processOrder(orderId).then(
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  rejectOrder({ _ }, { orderId, payloads }) {
    return new Promise((resolve, reject) => {
      api.order.rejectOrder(orderId, payloads).then(
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  retryPayment({ _ }, { orderId }) {
    return new Promise((resolve, reject) => {
      api.order.retry(orderId).then(
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  complain({ _ }, { orderId, payloads }) {
    return new Promise((resolve, reject) => {
      api.order.complain(orderId, payloads).then(
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  downloadShippingLabel({ _ }, { orderId }) {
    return new Promise((resolve, reject) => {
      api.order.downloadShippingLabel(orderId).then(
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  cancelOrder({ commit }, { orderId, reason }) {
    return new Promise((resolve, reject) => {
      api.order.cancelOrder(orderId, reason).then(
        response => {
          commit('setOrderDetail', response.data.data) // Adjust based on your API response structure
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getDraftOrders({ commit }, { params }) {
    return new Promise((resolve, reject) => {
      api.order.getDraftOrders(params).then(
        response => {
          commit('setDraftOrder', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  countDraftOrders({ _ }, { params }) {
    return new Promise((resolve, reject) => {
      api.order.countDraftOrders().then(
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getDraftOrderDetail({ commit }, { draftOrderId }) {
    return new Promise((resolve, reject) => {
      api.order.draftOrderDetail(draftOrderId).then(
        response => {
          commit('setDraftOrderDetail', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  createDraftOrder({ _ }, { payloads }) {
    return new Promise((resolve, reject) => {
      api.order.createDraftOrder(payloads).then(
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  updateDraftOrder({ _ }, { draftOrderId, payloads }) {
    return new Promise((resolve, reject) => {
      api.order.updateDraftOrder(draftOrderId, payloads).then(
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  deleteDraftOrder({ _ }, { draftOrderId }) {
    return new Promise((resolve, reject) => {
      api.order.deleteDraftOrder(draftOrderId).then(
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  updatePriceAdjustmentStatus({ _ }, { orderId, payloads }) {
    return new Promise((resolve, reject) => {
      api.order.updatePriceAdjustmentStatus(orderId, payloads).then(
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  }
}
const mutations = {
  setOrders(state, value) {
    state.orderList = value
  },
  setOrderDetail(state, value) {
    state.orderDetail = value
  },
  setTempOrders(state, value) {
    state.tempOrderList = value
  },
  setTempOrderDetail(state, value) {
    state.tempOrderDetail = value
  },
  setDraftOrder(state, value) {
    state.draftOrderList = value
  },
  setDraftOrderDetail(state, value) {
    state.draftOrderDetail = value
  }
}
const getters = {
  orderList: state => state.orderList,
  tempOrderList: state => state.tempOrderList,
  orderDetail: state => state.orderDetail,
  tempOrderDetail: state => state.tempOrderDetail,
  draftOrderList: state => state.draftOrderList,
  draftOrderDetail: state => state.draftOrderDetail
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
